/**
 * Konvertiert KI-Antworten mit Zeilenumbrüchen und einfachem Markdown zu HTML
 */
export function formatAIResponse(text: string): string {
  if (!text) return '';

  const result = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    // Zeilenumbrüche zu <br /> - ZUERST für den gesamten Text
    .replace(/\n/g, '<br />')
    
    // Code-Blöcke mit ``` umwandeln (mit oder ohne Sprachbezeichnung)
    .replace(/```(\w*)\n?([\s\S]*?)```/g, (_, __, code) => {
      // Korrigiere <br /> zurück zu \n innerhalb des Code-Blocks
      const cleanCode = code.replace(/<br \/>/g, '\n');
      return `<pre><code>${cleanCode
        .replace(/</g, '&lt;')   // HTML escapen
        .replace(/>/g, '&gt;')
        .trim()}</code></pre>`;
    })
    
    // Inline Code `code` 
    .replace(/`(.*?)`/g, '<code class="inline-code">$1</code>')
    
    // Doppelte Zeilenumbrüche zu Absätzen
    .replace(/<br \/><br \/>/g, '</p><p>')
    
    // Fett: **text** -> <strong>text</strong>
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    
    // Kursiv: *text* -> <em>text</em>
    .replace(/\*(.*?)\*/g, '<em>$1</em>')
    
    // Überschriften: # Text -> <h3>Text</h3>
    .replace(/^### (.*$)/gim, '<h3>$1</h3>')
    .replace(/^## (.*$)/gim, '<h2>$1</h2>')
    .replace(/^# (.*$)/gim, '<h1>$1</h1>')
    
    // Listen: * Text oder - Text -> <li>Text</li>
    .replace(/^[\*\-] (.*$)/gim, '<li>$1</li>')
    
    // Zusammenhängende Listen umschließen
    .replace(/(<li>.*<\/li>)(\s*<li>.*<\/li>)*/g, '<ul>$&</ul>')
    
    // Absätze am Anfang/Ende hinzufügen
    .replace(/^(?!.*<p>)/, '<p>')
    .replace(/(?<!<\/p>)$/, '</p>');

  return result;
}

/**
 * Sichere HTML-Erstellung mit dangerouslySetInnerHTML
 */
export function createMarkup(html: string) {
  return { __html: html };
}
